import { observable, action } from 'mobx';
import { OrganizationTypeahead } from '../models';
import { NotificationService, TypeaheadService } from '../services';

export class OrganizationStore {
    @observable selectedOrganizationId: number | undefined;
    @observable organizations: OrganizationTypeahead[];
    @observable organizationsLoaded: boolean;
    @observable errorLoadingOrganizations: boolean;

    private typeaheadService: TypeaheadService;

    constructor(notificationService: NotificationService) {
        // init observables
        this.organizationsLoaded = false;
        this.errorLoadingOrganizations = false;

        // init class members
        this.typeaheadService = new TypeaheadService(notificationService);
    }

    @action loadOrganizations() {
        return this.typeaheadService.getOrganizations()
            .then((organizations: OrganizationTypeahead[]) => {
                this.organizations = organizations;
                this.organizationsLoaded = true;

                if (organizations.length === 1) {
                    this.selectedOrganizationId = organizations[0].id;
                }
            })
            .catch(() => {
                this.organizationsLoaded = false;
                this.errorLoadingOrganizations = true;
            });
    }

    @action setSelectedOrganizationId(organizationId: number) {
        this.selectedOrganizationId = organizationId;
    }
}


// WEBPACK FOOTER //
// ./src/stores/OrganizationStore.tsx